<template>
  <div>
    <vx-card class="mb-4 card-search">
      <div class="mb-2 inline-block">
        <span class="md:w-auto w-24 ml-6 inline-block">검색기간 : </span>
        <v-select class="w-48 md:w-40 ml-2" :options="[{field: 'modifiedDatetime', label: '등록일'}, {field: 'structureChangeDate', label: '구조변경일'}, {field: 'lastCleaningDate', label: '최종 클리닝날짜'}, {field: 'reservationDate', label: '예약일자'}]" label="label" :reduce="option => option.field" v-model="search.dateType" :clearable="false" />
        <span class="ml-32 md:ml-2 mt-1 md:mt-0 inline-block">
          <flat-pickr style="width: 100px;" class="vs-inputx vs-input--input normal" v-model="search.startDate" />
          ~ <flat-pickr style="width: 100px;" class="vs-inputx vs-input--input normal" v-model="search.endDate" />
        </span>
      </div>
      <div class="mb-2 inline-block">
        <span class="md:w-auto w-24 ml-6 inline-block">장치인증번호 : </span>
        <v-select class="w-48 md:w-42 ml-2" :options="Object.keys($deviceTypes)" v-model="search.certificationNumber" />
      </div>
      <div class="mb-2 inline-block">
        <span class="md:w-auto w-24 ml-6 inline-block">지자체 : </span>
        <v-select class="w-48 md:w-38 ml-2" :options="$root.municipalities" v-model="search.municipality" />
      </div>
      <div class="mb-2 inline-block">
        <span class="md:w-auto w-24 ml-6 inline-block">운행지자체 : </span>
        <v-select class="w-48 md:w-38 ml-2" :options="$root.municipalities2" v-model="search.municipality2" />
      </div>
      <div class="mb-2 inline-block">
        <span class="md:w-auto w-24 ml-6 inline-block">운행지역 : </span>
        <v-select class="w-48 md:w-36 ml-2" :options="$root.regions" v-model="search.region" />
      </div>
      <div class="mb-2 inline-block">
        <span class="md:w-auto w-24 ml-6 inline-block">리스트일정 : </span>
        <v-select class="w-48 md:w-52 ml-2" :options="$root.listSchedules" v-model="search.listSchedule" />
      </div>
      <div class="mb-2 inline-block">
        <span class="md:w-auto w-24 ml-6 inline-block">잔여보조금 : </span>
        <v-select class="w-48 md:w-48 ml-2" :options="$root.remainSubsidies" v-model="search.remainSubsidy" />
      </div>
      <div class="mb-2 inline-block">
        <span class="md:w-auto w-24 ml-6 inline-block">정기/특별 : </span>
        <v-select class="w-48 md:w-38 ml-2" :options="$specials" v-model="search.special" />
      </div>
      <div class="mb-2 inline-block">
        <span class="md:w-auto w-24 ml-6 inline-block">진행상태 : </span>
        <v-select class="w-48 md:w-38 ml-2" :options="$statuses" v-model="search.status" />
      </div>
      <div class="mb-2 inline-block">
        <span class="md:w-auto w-24 ml-6 inline-block">필터상태 : </span>
        <v-select class="w-48 md:w-32 ml-2" :options="$filterStatuses" v-model="search.filterStatus" />
      </div>
      <div class="mb-2 inline-block">
        <span class="md:w-auto w-24 ml-6 inline-block">전화번호 : </span>
        <vs-input class="w-48 md:w-32 ml-2 inline-block" :disabled="search.vehicleNumber!=null && search.vehicleNumber.length>0" v-model="search.phone" @keyup.enter="reload" />
      </div>
      <div class="mb-2 inline-block">
        <span class="md:w-auto w-24 ml-6 inline-block">차량번호 : </span>
        <vs-input class="w-48 md:w-32 ml-2 inline-block" :disabled="search.phone!=null && search.phone.length>0" v-model="search.vehicleNumber" @keyup.enter="reload" />
      </div>
      <div class="mb-2 inline-block" v-if="$store.state.AppActiveUser.vendors.length >= 2">
        <span class="md:w-auto w-24 ml-6 inline-block">제작사 : </span>
        <v-select class="w-48 md:w-38 ml-2" :options="$vendors" v-model="search.vendor" />
      </div>
      <div class="mb-2 inline-block">
        <span class="md:w-auto w-24 ml-6 inline-block">차대번호 : </span>
        <vs-input class="w-48 md:w-48 ml-2 inline-block" v-model="search.vehicleId" @keyup.enter="reload" />
      </div>
      <div class="mb-2 inline-block">
        <span class="md:w-auto w-24 ml-6 inline-block">처리기사 : </span>
        <v-select class="w-48 md:w-42 ml-2" :options="$root.engineers" v-model="search.engineer" />
      </div>
      <div class="mb-2 inline-block">
        <span class="md:w-auto w-24 ml-6 inline-block">수정자 : </span>
        <vs-input class="w-48 md:w-24 ml-2 inline-block" v-model="search.modifiedManager" @keyup.enter="reload" />
      </div>
      <div style="float:right;">
        <vs-button class="mr-1" @click="reload">검색</vs-button>
        <vs-button color="success" @click="resetSearch">검색 초기화</vs-button>
      </div>
      <div style="clear:both;"></div>
    </vx-card>

    <vx-card>
      <div class="mb-4 h-12">
        <vs-button v-if="$store.state.AppActiveUser.role>=5" class="mr-1" @click="openImportPopup">Excel 업로드</vs-button>
        <vs-button v-if="$store.state.AppActiveUser.role>=5" @click="openRegisterPopup">심사 등록</vs-button>
        <vs-button class="float-right ml-4" @click="excel">Excel 다운로드</vs-button>
        <span v-if="itemCnt != null" class="float-right text-2xl mt-1">총 {{ itemCnt }}건</span>
      </div>
      <vs-table :pagination="!limitItems" max-items="30" :data="audits" @selected="handleSelected" noDataText="검색 결과가 없습니다.">

        <template slot="thead">
          <vs-th v-if="!limitItems">순번</vs-th>
          <vs-th>제작사</vs-th>
          <vs-th>상태</vs-th>
          <vs-th>지자체</vs-th>
          <vs-th>운행지자체</vs-th>
          <vs-th>운행지역</vs-th>
          <vs-th>차명</vs-th>
          <vs-th>구조변경일</vs-th>
          <vs-th>차량번호</vs-th>
          <vs-th>최종연락처</vs-th>
          <vs-th>최종 클리닝 일시</vs-th>
          <vs-th>잔여보조금</vs-th>
          <vs-th>예약일자</vs-th>
          <vs-th>리스트일정</vs-th>
          <vs-th>장치종류</vs-th>
          <vs-th>출력</vs-th>
          <vs-th>서명</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :id="tr.id">
            <vs-td v-if="!limitItems">{{ tr.seq }}</vs-td>
            <vs-td>{{ tr.vendor }}</vs-td>
            <vs-td>{{ tr.status }}</vs-td>
            <vs-td>{{ tr.municipality }}</vs-td>
            <vs-td>{{ tr.municipality2 }}</vs-td>
            <vs-td>{{ tr.region }}</vs-td>
            <vs-td>{{ tr.vehicleName }}</vs-td>
            <vs-td>{{ tr.structureChangeDate }}</vs-td>
            <vs-td>{{ tr.vehicleNumber }}</vs-td>
            <vs-td>{{ tr.phone }}</vs-td>
            <vs-td>{{ tr.lastCleaningDate }}</vs-td>
            <vs-td>{{ tr.remainSubsidy }}</vs-td>
            <vs-td>{{ tr.reservationDate }}</vs-td>
            <vs-td>{{ tr.listSchedule }}</vs-td>
            <vs-td>{{ $deviceTypes[tr.certificationNumber] }}</vs-td>
            <vs-td onclick="event.cancelBubble=true">
              <feather-icon icon="FileTextIcon" color="primary" svgClasses="h-6 w-5" @click.stop="showNormalCleaning(tr)"/>&nbsp;

              <vs-dropdown>
                <!-- <a class="a-icon" href="#"> -->
                  <feather-icon icon="PrinterIcon" color="primary" svgClasses="h-6 w-5"/>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click.stop="showCertificate(tr)">
                      확인증명서
                    </vs-dropdown-item>
                    <vs-dropdown-item @click.stop="showAgreement(tr)">
                      필터 교체 동의서
                    </vs-dropdown-item>
                    <vs-dropdown-item @click.stop="showPhoto(tr)">
                      클리닝 사진
                    </vs-dropdown-item>
                    <vs-dropdown-item @click.stop="showNormalCleaning(tr)">
                      적정 클리닝 확인서
                    </vs-dropdown-item>
                    <vs-dropdown-item @click.stop="showSpecialCleaning(tr)">
                      특별 클리닝 신청서
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                <!-- </a> -->
              </vs-dropdown>
            </vs-td>
            <vs-td onclick="event.cancelBubble=true">
              <a href="javascript:void(0);" @click.stop="showSignPad(tr)">차주</a>&nbsp;
              <a href="javascript:void(0);" @click.stop="showSignPadEngineer(tr)">기사</a>&nbsp;
              <a href="javascript:void(0);" style="color: red;" @click.stop="deleteSign(tr)">삭제</a>
            </vs-td>
          </vs-tr>
        </template>

      </vs-table>
    </vx-card>

    <detail-popup ref="detailPopup" @reload="reload" />
    <import-popup ref="importPopup" @reload="reload" />
    <certificate-popup ref="certificatePopup" />
    <agreement-popup ref="agreementPopup" />
    <photo-popup ref="photoPopup" />
    <normal-cleaning-popup ref="normalCleaningPopup" />
    <special-cleaning-popup ref="specialCleaningPopup" />
    <sign-pad-popup ref="signPadPopup" />
    <sign-pad-engineer-popup ref="signPadEngineerPopup" />
  </div>
</template>

<script>
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import DetailPopup from './components/DetailPopup.vue'
import ImportPopup from './components/ImportPopup.vue'
import CertificatePopup from './components/CertificatePopup.vue'
import AgreementPopup from './components/AgreementPopup.vue'
import PhotoPopup from './components/PhotoPopup.vue'
import NormalCleaningPopup from './components/NormalCleaningPopup.vue'
import SpecialCleaningPopup from './components/SpecialCleaningPopup.vue'
import SignPadPopup from './components/SignPadPopup.vue'
import SignPadEngineerPopup from './components/SignPadEngineerPopup.vue'

export default {
  data () {
    return {
      audits: [],
      search: {
        dateType: 'modifiedDatetime'
      },
      loading: false,
      offset1: null,
      offset2: null,
      moreData: true,
      itemCnt: null,
      limitItems: true
    }
  },
  created () {
    // this.loadData()
    this.reload()
  },
  methods: {
    reload () {
      this.audits = []
      this.offset1 = null
      this.offset2 = null
      this.moreData = true
      this.loadData()
    },
    loadData () {
      if (this.loading || !this.moreData) {
        return
      }
      this.$vs.loading()
      this.loading = true

      let query = this.getQuery()
      if (this.offset1) {
        query = query.startAfter(this.offset1, `${this.offset2}`)
      }
      if (this.limitItems) {
        query = query.limit(50)
      }
      query.get().then((querySnapshot) => {
        this.loading = false
        if (!this.limitItems) {
          if (this.offset1) {
            this.itemCnt += querySnapshot.docs.length
          } else {
            this.itemCnt = querySnapshot.docs.length
          }
        } else {
          this.itemCnt = null
        }
        if (querySnapshot.docs.length >= 50) {
          this.moreData = true
        } else {
          this.moreData = false
        }
        if (querySnapshot.docs.length > 0) {
          const last = querySnapshot.docs[querySnapshot.docs.length - 1].data()
          if (this.search.startDate || this.search.endDate) {
            this.offset1 = last[this.search.dateType]
          } else {
            this.offset1 = last['structureChangeDate']
          }
          this.offset2 = last['vehicleId']
          let seq = querySnapshot.docs.length
          querySnapshot.forEach((doc) => {
            const data = doc.data()
            data.id = doc.id
            if (!data.prevCleaningDate && data.prefCleaningDate) {
              data.prevCleaningDate = data.prefCleaningDate
            }
            data.seq = seq--
            this.audits.push(data)
          })
        }
        this.$vs.loading.close()
      })
    },
    handleSelected (audit) {
      this.$refs.detailPopup.open(audit, false)
    },
    openImportPopup () {
      this.$refs.importPopup.open()
    },
    openRegisterPopup () {
      this.$refs.detailPopup.open(null, false)
    },
    showCertificate (audit) {
      this.$refs.certificatePopup.open(audit)
    },
    showAgreement (audit) {
      this.$refs.agreementPopup.open(audit)
    },
    showPhoto (audit) {
      this.$refs.photoPopup.open(audit.image, true)
    },
    showNormalCleaning (audit) {
      this.$refs.normalCleaningPopup.open(audit)
    },
    showSpecialCleaning (audit) {
      this.$refs.specialCleaningPopup.open(audit)
    },
    showSignPad (audit) {
      this.$refs.signPadPopup.open(audit)
    },
    showSignPadEngineer (audit) {
      this.$refs.signPadEngineerPopup.open(audit)
    },
    deleteSign (audit) {
      if (confirm('서명을 삭제하시겠습니까?')) {
        const data = {}
        data.signature = ''
        data.signatureEngineer = ''
        this.$db.collection('installations').doc(audit.id).update(data).then(() => {
          alert('서명을 삭제했습니다.')
          audit.signature = ''
          audit.signatureEngineer = ''
        })
      }
    },
    resetSearch () {
      this.search = {
        dateType: '등록일'
      }
    },
    onScroll () {
      const bottomOfWindow = document.documentElement.scrollTop + window.innerHeight >= document.getElementById('app').offsetHeight - 200

      if (bottomOfWindow) {
        this.loadData()
      }
    },
    getQuery () {
      this.limitItems = true
      let query = this.$db.collection('installations')
      if (this.search.startDate) {
        if (this.search.dateType === 'modifiedDatetime') {
          const start = new Date(this.search.startDate)
          query = query.where(this.search.dateType, '>=', start)
        } else {
          query = query.where(this.search.dateType, '>=', this.search.startDate)
        }
        this.limitItems = false
      }
      if (this.search.endDate) {
        if (this.search.dateType === 'modifiedDatetime') {
          const end = new Date(`${this.search.endDate} 23:59:59`)
          query = query.where(this.search.dateType, '<=', end)
        } else {
          query = query.where(this.search.dateType, '<=', this.search.endDate)
        }
        this.limitItems = false
      }
      if (this.search.certificationNumber) {
        query = query.where('certificationNumber', '==', this.search.certificationNumber)
      }
      if (this.search.municipality) {
        query = query.where('municipality', '==', this.search.municipality)
        this.limitItems = false
      }
      if (this.search.municipality2) {
        query = query.where('municipality2', '==', this.search.municipality2)
        this.limitItems = false
      }
      if (this.search.region) {
        query = query.where('region', '==', this.search.region)
        this.limitItems = false
      }
      if (this.search.listSchedule) {
        query = query.where('listSchedule', '==', this.search.listSchedule)
        this.limitItems = false
      }
      if (this.search.remainSubsidy) {
        query = query.where('remainSubsidy', '==', this.search.remainSubsidy)
        // this.limitItems = false
      }
      if (this.search.special) {
        query = query.where('special', '==', this.search.special)
        // this.limitItems = false
      }
      if (this.search.status) {
        query = query.where('status', '==', this.search.status)
        this.limitItems = false
      }
      if (this.search.filterStatus) {
        query = query.where('filterStatus', '==', this.search.filterStatus)
        this.limitItems = false
      }
      if (this.search.phone) {
        query = query.where('phoneNumbers', 'array-contains', this.search.phone)
        this.limitItems = false
      }
      if (this.search.vehicleNumber) {
        query = query.where('vehicleNumbers', 'array-contains', this.search.vehicleNumber)
        this.limitItems = false
      }
      if (this.search.vendor) {
        query = query.where('vendor', '==', this.search.vendor)
        this.limitItems = false
      }
      if (this.search.vehicleId) {
        query = query.where('vehicleId', '==', this.search.vehicleId)
        this.limitItems = false
      } else {
        if (this.search.startDate || this.search.endDate) {
          query = query.orderBy(this.search.dateType, 'desc')
        } else {
          query = query.orderBy('structureChangeDate', 'desc')
        }
        query = query.orderBy('vehicleId')
      }
      if (this.search.engineer) {
        query = query.where('engineer', '==', this.search.engineer)
        this.limitItems = false
      }
      if (this.search.modifiedManager) {
        query = query.where('modifiedManager', '==', this.search.modifiedManager)
        this.limitItems = false
      }
      if (this.$store.state.AppActiveUser.vendors.length < 2) {
        query = query.where('vendor', '==', this.$store.state.AppActiveUser.vendors[0])
      }
      return query
    },
    excel () {
      const headerTitle = ['순번', '제작사', '지자체', '차량번호', '현재차량번호', '차명', '구조변경일', '연락처', '최종연락처', '예약날짜', '리스트일정', '비고', '장치종류', '차대번호', '진행 상태', '잔여 보조금', '최종클리닝일자', '운행지자체', '운행지역', '필터상태', '참고사항']
      const headerVal = ['seq', 'vendor', 'municipality', 'vehicleNumber', 'currentVehicleNumber', 'vehicleName', 'structureChangeDate', 'phone', 'lastPhone', 'reservationDate', 'listSchedule', 'remark', 'deviceType', 'vehicleId', 'status', 'remainSubsidy', 'lastCleaningDate', 'municipality2', 'region', 'filterStatus', 'note']
      const filename = '장착심사목록'

      this.$vs.loading()
      this.getQuery().get().then((querySnapshot) => {
        const list = []
        if (querySnapshot.docs.length > 0) {
          let i = 1
          querySnapshot.forEach((doc) => {
            const data = doc.data()
            data.seq = i++
            list.push(data)
          })
        }

        import('@/vendor/Export2Excel').then(excel => {
          const data = this.formatJson(headerVal, list)
          excel.export_json_to_excel({
            header: headerTitle,
            data,
            filename,
            autoWidth: true,
            bookType: 'xlsx'
          })

          this.$vs.loading.close()
        })
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'deviceType') {
          return this.$deviceTypes[v['certificationNumber']]
        }
        return v[j]
      }))
    }
  },
  components: {
    vSelect,
    flatPickr,
    DetailPopup,
    ImportPopup,
    CertificatePopup,
    AgreementPopup,
    PhotoPopup,
    NormalCleaningPopup,
    SpecialCleaningPopup,
    SignPadPopup,
    SignPadEngineerPopup
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll, false)
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScroll, false)
  }
}
</script>

<style lang="scss">
.summary {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.v-select {
  display: inline-block !important;
}

.card-search .vx-card__body {
  padding-left: 0 !important;
  padding-bottom: 1rem !important;
}
</style>
